import { createRoot } from 'react-dom/client';

import initializeSentry from '@oas/lib/sentry/initializeSentry';
import App from './app/App';

const root = createRoot(document.getElementById('root') as HTMLElement);

async function start() {
    // TODO: add some other conditions
    if (process.env.NODE_ENV !== 'production') {
        const [
            { worker },
            { mocksEnabled },
            { registerGql },
            {
                borrowerLoginGqlStub,
                mfaChallengeGqlStub,
                mfaLoginGqlStub,
                sendResetPasswordLinkGqlStub,
                checkResetTokenGqlStub,
                setNewPasswordGqlStub,
            },
            { lmsServiceGqlStub },
        ] = await Promise.all([
            import('@core/infrastructure/mocks/msw-worker'),
            import('@core/infrastructure/mocks/shim'),
            import('@core/infrastructure/mocks/adapters/graphql'),
            import('@core/auth/__stubs__/auth-gql-stubs'),
            import('@oas/tests/utils/lmsServiceResponseMocks'),
        ]);

        if (mocksEnabled()) {
            await worker.start();
            registerGql(borrowerLoginGqlStub);
            registerGql(mfaChallengeGqlStub);
            registerGql(mfaLoginGqlStub);
            registerGql(sendResetPasswordLinkGqlStub);
            registerGql(checkResetTokenGqlStub);
            registerGql(setNewPasswordGqlStub);
            registerGql(lmsServiceGqlStub);
        }
    }

    root.render(<App />);
}

initializeSentry();
start();
